import _map from 'lodash/map';
import { DETAILS_VIEW_REGISTRATION } from '@constants';
import _get from 'lodash/get';
type Props = {
  registration: object;
};
const RegoPaper = ({ registration }: Props) => {
  return (
    <>
      {_map(
        DETAILS_VIEW_REGISTRATION,
        (row: any, index: number) =>
          _get(registration, row.keyPath) && (
            <div
              key={index}
              className="flex justify-between md:justify-start flex-row-reverse flex-row md:flex-col items-start gap-2 ">
              <p className="text-base text-grey-700 break-words text-right md:text-left">
                {typeof _get(registration, row.keyPath) === 'object'
                  ? _get(registration, row.keyPath).userEditValue
                    ? _get(registration, row.keyPath).userEditValue
                    : _get(registration, row.keyPath).ocrValue &&
                      _get(registration, row.keyPath).ocrValue
                  : _get(registration, row.keyPath)}
              </p>
              <p className="text-grey-500 text-xs leading-5">
                {row.displayName}
              </p>
            </div>
          )
      )}
    </>
  );
};
export default RegoPaper;
